import { render, staticRenderFns } from "./editRanking.vue?vue&type=template&id=92fd7c24&"
import script from "./editRanking.vue?vue&type=script&lang=js&"
export * from "./editRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports